// extracted by mini-css-extract-plugin
module.exports = {"snsHero":"safetyAndSupportPage_snsHero__v5EVC","headerText":"safetyAndSupportPage_headerText__mO4Tl","bodyContainer":"safetyAndSupportPage_bodyContainer__QO7sY"};